export const ALLOWED_EXTENSIONS = ['.jpeg', '.jpg', '.png'];
